import * as React from "react";
import { SVGProps } from "react";
const SvgLogoGoogle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={18}
    height={18}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#logo-google_svg__a)">
      <path
        d="M17.617 9.203c0-.593-.052-1.155-.142-1.703H9v3.383h4.852c-.217 1.11-.854 2.047-1.8 2.685v2.25h2.896c1.694-1.568 2.67-3.878 2.67-6.615Z"
        fill="#4285F4"
      />
      <path
        d="M9 18c2.43 0 4.463-.81 5.947-2.182l-2.894-2.25c-.81.54-1.838.87-3.053.87-2.347 0-4.335-1.583-5.047-3.72H.968v2.317C2.445 15.975 5.483 18 9 18Z"
        fill="#34A853"
      />
      <path
        d="M3.953 10.718A5.223 5.223 0 0 1 3.667 9c0-.6.104-1.177.284-1.717V4.965H.968a8.896 8.896 0 0 0 0 8.07l2.986-2.317Z"
        fill="#FBBC05"
      />
      <path
        d="M9 3.563c1.328 0 2.512.457 3.45 1.35l2.565-2.566C13.462.894 11.43 0 9 0 5.483 0 2.445 2.025.968 4.965l2.985 2.317c.712-2.137 2.7-3.72 5.047-3.72Z"
        fill="#EA4335"
      />
    </g>
    <defs>
      <clipPath id="logo-google_svg__a">
        <path fill="#fff" d="M0 0h18v18H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgLogoGoogle;
